// アフリカの世界史スポット。
// 古代エジプト、ナイル上流のクシュ王国、地中海のフェニキア、サハラ交易の西アフリカ、
// インド洋・大西洋世界とのつながりを代表させる。
//
// グレート・ジンバブエは植民地期に「アフリカ人には造れない」とされた経緯があるため、
// 現地のショナ系社会が築いたことを解説文で明記する。
// ゴレ島は追悼の場のため ○×クイズを付けない。

export const AFRICA_SITES = [
  {
    id: 'giza-pyramids',
    name: 'ギザの三大ピラミッド',
    nameEn: 'Great Pyramids of Giza',
    lat: 29.9792, lng: 31.1342, elevationM: 60,
    region: 'africa', era: 'ancient',
    country: 'エジプト（ギザ県）',
    civilization: '古代エジプト 古王国 第4王朝',
    yearLabel: '前2560年頃（クフ王のピラミッド）',
    whcYear: 1979,
    whcNote: '「メンフィスとその墓地遺跡」の一部',
    emoji: '🔺',
    facts: [
      { label: '高さ', value: '建造時 146.6m ／ 現在 約138.8m' },
      { label: '石材', value: '平均2.5トンの石灰岩ブロック 約230万個' },
    ],
    summary:
      '前2500年頃、エジプト古王国第4王朝のクフ王・カフラー王・メンカウラー王が、ナイル川西岸のギザ台地に築いた王墓群。最大のクフ王のピラミッドは平均2.5トンの石灰岩ブロックを約230万個積み上げ、建造時の高さは146.6mに達した。建設を担ったのは奴隷ではなく、ナイルの増水で農作業ができない時期にパンやビールを報酬として組織的に動員された農民だったと考えられている。定期的な氾濫を利用した灌漑農業の余剰と、太陽神ラーの子とされたファラオへの権力集中を可視化した記念物である。',
    quiz: {
      statement: 'クフ王のピラミッドは、鞭で打たれる奴隷たちの労働によって建設されたことが発掘で確かめられている。',
      answer: false,
      explain: 'ピラミッドのそばで建設労働者の集落と墓が発掘され、彼らがパンやビールの配給を受け、骨折の治療まで受けていたことが分かりました。ヘロドトスが伝えた奴隷労働説は現在では否定的にみられています。',
    },
  },
  {
    id: 'karnak',
    name: 'カルナック神殿（ルクソール）',
    nameEn: 'Karnak Temple',
    lat: 25.7188, lng: 32.6573, elevationM: 78,
    region: 'africa', era: 'ancient',
    country: 'エジプト（ルクソール）',
    civilization: '古代エジプト 中王国〜新王国',
    yearLabel: '前20世紀頃〜前1世紀（歴代の王が増築）',
    whcYear: 1979,
    whcNote: '「古代都市テーベとその墓地遺跡」の一部',
    emoji: '🏛',
    summary:
      '古代エジプトの都テーベ（現ルクソール）にあり、国家神アメン＝ラーに捧げられた巨大な神殿複合体。中王国期から2千年近くにわたり歴代の王が増築を重ね、大列柱室には高さ20mを超える134本の円柱が林立する。新王国期にはトトメス3世がシリアまで遠征して領土を最大にし、その戦利品が神殿と神官団を潤した。アメンホテプ4世（イクナートン）はアテン一神教を唱えてこの神官団の力を抑えようとしたが、その死後まもなく旧来の信仰が復活している。',
    quiz: {
      statement: 'アメンホテプ4世（イクナートン）は、アテン神をただ一つの神とする宗教改革を行った。',
      answer: true,
      explain: 'アメンホテプ4世はアメン神官団の力を抑えるため、アテンのみを崇拝する改革を断行し、都もテル＝エル＝アマルナへ移しました。その死後、改革は覆されます。',
    },
  },
  {
    id: 'abu-simbel',
    name: 'アブ・シンベル神殿',
    nameEn: 'Abu Simbel',
    lat: 22.3372, lng: 31.6258, elevationM: 180,
    region: 'africa', era: 'ancient',
    country: 'エジプト（アスワン県）',
    civilization: '古代エジプト 新王国 第19王朝',
    yearLabel: '前13世紀（ラメセス2世）',
    whcYear: 1979,
    whcNote: '「アブ・シンベルからフィラエまでのヌビア遺跡群」',
    emoji: '🗿',
    facts: [
      { label: '移設', value: '1960年代にユネスコの国際キャンペーンで約60m上方へ' },
    ],
    summary:
      '前13世紀、新王国第19王朝のラメセス2世がヌビアの岩山を彫り抜いて造らせた神殿。正面には高さ約20mの座像が4体並び、南方のヌビア人に対してエジプト王の威光を示す意図があったとされる。ラメセス2世はヒッタイトとカデシュで戦い、のちに国際条約を結んだ王でもある。1960年代、アスワン・ハイダム建設によって水没が迫ると、ユネスコが国際的な救済キャンペーンを展開して神殿を切り出し約60m上方へ移設した。これが世界遺産条約（1972年）を生む直接のきっかけとなった。',
    quiz: {
      statement: 'アブ・シンベル神殿の救済活動は、のちの世界遺産条約が生まれるきっかけとなった。',
      answer: true,
      explain: 'アスワン・ハイダムによる水没から神殿を救うユネスコの国際キャンペーンが成功し、人類共通の遺産を守るという理念が1972年の世界遺産条約へ結実しました。',
    },
  },
  {
    id: 'meroe',
    name: 'メロエのピラミッド群',
    nameEn: 'Pyramids of Meroë',
    lat: 16.9370, lng: 33.7490, elevationM: 360,
    region: 'africa', era: 'ancient',
    country: 'スーダン（ナイル川州）',
    civilization: 'クシュ王国（メロエ）',
    yearLabel: '前3世紀〜後4世紀',
    whcYear: 2011,
    emoji: '🔺',
    summary:
      'ナイル川上流のヌビアに栄えたクシュ王国が、都をメロエに移した後に築いた王墓群。エジプトのものより小ぶりで傾斜の急なピラミッドが200基以上並ぶ。クシュは前8世紀に一時エジプトを征服して第25王朝を打ち立てた強国で、その後もエジプト文化を受け継ぎつつ独自のメロエ文字を生み出した。鉄の生産と、紅海・サハラを結ぶ交易で栄えたが、4世紀にアクスム王国の攻撃を受けて衰退する。アフリカがエジプト以外にも高度な国家を育てていたことを示す遺跡である。',
    quiz: {
      statement: 'クシュ王国は一時エジプトを征服し、ファラオの王朝（第25王朝）を打ち立てたことがある。',
      answer: true,
      explain: '前8世紀、クシュの王ピイらがエジプトを征服し第25王朝を開きました。「黒いファラオ」と呼ばれ、約100年間エジプトを支配しています。',
    },
  },
  {
    id: 'carthage',
    name: 'カルタゴ遺跡',
    nameEn: 'Carthage',
    lat: 36.8528, lng: 10.3233, elevationM: 30,
    region: 'africa', era: 'ancient',
    country: 'チュニジア（チュニス県）',
    civilization: 'フェニキア／ローマ',
    yearLabel: '前9世紀頃 建設 / 前146年 ローマが破壊',
    whcYear: 1979,
    emoji: '⛵',
    summary:
      'フェニキア人が前9世紀頃に地中海南岸に築いた植民市。フェニキア人は表音文字であるアルファベットの原型を生み、それがギリシアを経てヨーロッパの文字へつながった。カルタゴは西地中海の交易を握って強大化し、前3世紀からローマと三次にわたるポエニ戦争を戦う。第二次ではハンニバルが象を連れてアルプスを越え、カンネーの戦いでローマ軍を壊滅させたが、最終的にザマで敗れた。前146年に徹底的に破壊され、のちローマの属州都市として再建された。',
    quiz: {
      statement: 'ポエニ戦争でカルタゴの将軍ハンニバルは、アルプスを越えてイタリア半島に侵入した。',
      answer: true,
      explain: '第二次ポエニ戦争でハンニバルは象を含む軍を率いてアルプスを越え、カンネーの戦いでローマ軍を破りました。しかし最終的にザマの戦いで敗れます。',
    },
  },
  {
    id: 'aksum',
    name: 'アクスムのオベリスク群',
    nameEn: 'Obelisks of Aksum',
    lat: 14.1310, lng: 38.7190, elevationM: 2130,
    region: 'africa', era: 'ancient',
    country: 'エチオピア（ティグレ州）',
    civilization: 'アクスム王国',
    yearLabel: '3〜4世紀頃',
    whcYear: 1980,
    emoji: '🗿',
    summary:
      'エチオピア高原に興ったアクスム王国が、王の墓標として立てた花崗岩の石柱群。最大のものは高さ30mを超える。紅海の交易を押さえてローマ帝国やインドと結び、独自のゲエズ文字と貨幣を持った。4世紀にはエザナ王がキリスト教を受け入れ、これはローマ帝国の公認とほぼ同時期にあたる。以後エチオピアはイスラーム世界に囲まれながらキリスト教を保ち続け、ヨーロッパで語られた「プレスター・ジョンの国」の伝説の一因ともなった。',
    quiz: {
      statement: 'アクスム王国は4世紀にキリスト教を受け入れ、以後エチオピアはキリスト教国であり続けた。',
      answer: true,
      explain: 'エザナ王の改宗はローマ帝国がキリスト教を公認した時期とほぼ重なります。エチオピア正教会は現在まで続く、世界でも古い教会のひとつです。',
    },
  },
  {
    id: 'timbuktu',
    name: 'トンブクトゥ',
    nameEn: 'Timbuktu',
    lat: 16.7735, lng: -3.0074, elevationM: 260,
    region: 'africa', era: 'medieval',
    country: 'マリ（トンブクトゥ州）',
    civilization: 'マリ帝国・ソンガイ帝国',
    yearLabel: '14〜16世紀に最盛',
    whcYear: 1988,
    emoji: '🕌',
    summary:
      'ニジェール川の湾曲部に近い、サハラ縦断交易の南の玄関口。北から岩塩、南から金と奴隷が運ばれ、その富がマリ帝国とソンガイ帝国を支えた。マリ帝国のマンサ・ムーサは1324年のメッカ巡礼で大量の金を費やし、通過したカイロの金相場が下落したという逸話を残している。ジンガレベル・モスクなど日干し煉瓦の建築群が残り、サンコーレ・マドラサはイスラーム学問の一大中心となった。「文字を持たない大陸」という誤ったイメージを覆す写本群がここに伝わる。',
    quiz: {
      statement: 'サハラ縦断交易では、北アフリカからもたらされる岩塩と、西アフリカ産の金が交換された。',
      answer: true,
      explain: 'サハラ以南では塩が貴重で、逆に金は豊富に産出しました。この塩金交易がガーナ・マリ・ソンガイという西アフリカの諸帝国を潤しました。',
    },
  },
  {
    id: 'great-zimbabwe',
    name: 'グレート・ジンバブエ遺跡',
    nameEn: 'Great Zimbabwe',
    lat: -20.2675, lng: 30.9339, elevationM: 1100,
    region: 'africa', era: 'medieval',
    country: 'ジンバブエ（マシンゴ州）',
    civilization: 'ショナ系社会（ジンバブエ王国）',
    yearLabel: '11〜15世紀',
    whcYear: 1986,
    emoji: '🏛',
    summary:
      'モルタルを使わず花崗岩を精緻に積み上げた石造建築群で、「ジンバブエ」はショナ語で「石の家」を意味する。11世紀から15世紀にかけて、この地のショナ系の社会が築いたことが考古学的に確かめられている。内陸の金と象牙を、インド洋沿岸のキルワなどスワヒリ海岸の港市を介して、アラビアやインド、中国にまで送り出す交易の中心地だった。実際に中国製の陶磁器やペルシアのガラスが出土している。植民地時代には「アフリカ人には造れない」とする言説が唱えられたが、根拠のないものである。',
    quiz: {
      statement: 'グレート・ジンバブエの石造建築群は、この地のショナ系社会によって築かれた。',
      answer: true,
      explain: '考古学的な調査で、11〜15世紀に現地のショナ系社会が築いたことが確かめられています。植民地期の「外来民族起源説」は人種偏見に基づくもので、否定されています。',
    },
  },
  {
    id: 'goree-island',
    name: 'ゴレ島',
    nameEn: 'Île de Gorée',
    lat: 14.6670, lng: -17.3980, elevationM: 10,
    region: 'africa', era: 'earlymodern',
    country: 'セネガル（ダカール）',
    civilization: '大西洋奴隷貿易',
    yearLabel: '15〜19世紀',
    whcYear: 1978,
    emoji: '⛓',
    summary:
      'ダカール沖に浮かぶ小島。15世紀にポルトガル人が到達して以来、オランダ・イギリス・フランスが争って支配し、西アフリカ沿岸における大西洋奴隷貿易の拠点のひとつとなった。ヨーロッパから武器や織物をアフリカへ、アフリカから奴隷を新大陸へ、新大陸から砂糖・綿花をヨーロッパへ運ぶ三角貿易は、ヨーロッパの資本蓄積を支える一方で、アフリカ社会から数世紀にわたって膨大な人々を奪った。「奴隷の家」と「帰らざる扉」が残り、1978年に最初期の世界遺産のひとつとして登録された。',
    // 追悼施設: クイズも「NEW!」バッジも出さない。
    solemn: true,
    quiz: null,
  },
  {
    id: 'cape-of-good-hope',
    name: '喜望峰',
    nameEn: 'Cape of Good Hope',
    lat: -34.3568, lng: 18.4740, elevationM: 60,
    region: 'africa', era: 'earlymodern',
    country: '南アフリカ（西ケープ州）',
    civilization: '大航海時代',
    yearLabel: '1488年 バルトロメウ・ディアスが到達',
    whcYear: 2004,
    whcNote: '「ケープ植物区保護地域群」の一部',
    emoji: '⛵',
    summary:
      'アフリカ大陸南西端の岬。1488年にポルトガルのバルトロメウ・ディアスが到達し、当初は「嵐の岬」と名づけたが、インドへの航路が開ける希望から国王ジョアン2世が「喜望峰」と改めたと伝わる。1498年にはヴァスコ・ダ・ガマがここを回ってインドのカリカットに到達し、ヨーロッパとアジアを海路で直結させた。これにより地中海とイスラーム商人を経由してきた香辛料交易の構造が変わり、大西洋とインド洋を結ぶ世界規模の交易網が動き始める。',
    quiz: {
      statement: '喜望峰を回ってインド航路を開いたのは、コロンブスである。',
      answer: false,
      explain: '喜望峰経由でインドのカリカットに到達したのはヴァスコ・ダ・ガマ（1498年）です。コロンブスは1492年に大西洋を西へ渡り、カリブ海の島に到達しました。',
    },
  },
];
